import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/plans/new')({
  beforeLoad: () => {
    throw redirect({to: '/settings/nutrition-plans/new', replace: true});
  },
});
